module.exports = __webpack_public_path__ + "img/Checkmark-yellow.751e0969.svg";